import * as R from 'ramda';

export const getTotalPercentage = R.compose(R.sum, R.map(R.compose(R.defaultTo(0), Number)), R.pluck('Percentage'));
const toPinnedBottomRowData = R.compose(R.of, R.objOf('Percentage'));
export const getPinnedBottomRowData = R.compose(toPinnedBottomRowData, getTotalPercentage);
